export default __webpack_public_path__ + "static/media/CNo.85-1.36267f5c.jpg";